// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-9Nn","icon":"styles_icon__3xz_L"};